import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const addHomeVisitConfig = (configData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_HOME_VISIT_CONFIG_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/vr-home-visit/add`,  
        configData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "ADD_HOME_VISIT_CONFIG_SUCCESS",
          payload: data,
        });
        toast.success("Config added successfully!");
        return data;
      } else {
        dispatch({
          type: "ADD_HOME_VISIT_CONFIG_FAILED",
          payload: data,
        });
        toast.error("Failed to add config.");
        return data;
      }
    } catch (error) {
      const errorData =
        error?.response?.data || {
          statusCode: 500,
          message: "Something went wrong.",
        };
      dispatch({
        type: "ADD_HOME_VISIT_CONFIG_FAILED",
        payload: errorData,
      });
      toast.error(errorData.message);
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const updateHomeVisitConfig = (id, configData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_HOME_VISIT_CONFIG_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.put(
        `${BASE_URL}/vr-home-visit/update/${id}`,   
        configData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "UPDATE_HOME_VISIT_CONFIG_SUCCESS",
          payload: data,
        });
        // toast.success("Config updated successfully!");
        return data;
      } else {
        dispatch({
          type: "UPDATE_HOME_VISIT_CONFIG_FAILED",
          payload: data,
        });
        toast.error("Failed to update config.");
        return data;
      }
    } catch (error) {
      const errorData =
        error?.response?.data || {
          statusCode: 500,
          message: "Something went wrong.",
        };
      dispatch({
        type: "UPDATE_HOME_VISIT_CONFIG_FAILED",
        payload: errorData,
      });
      toast.error(errorData.message);
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const deleteHomeVisitConfig = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "DELETE_HOME_VISIT_CONFIG_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.delete(
        `${BASE_URL}/vr-home-visit/delete/${id}`,   
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "DELETE_HOME_VISIT_CONFIG_SUCCESS",
          payload: data,
        });
        toast.success("Config deleted successfully!");
        return data;
      } else {
        dispatch({
          type: "DELETE_HOME_VISIT_CONFIG_FAILED",
          payload: data,
        });
        toast.error("Failed to delete config.");
        return data;
      }
    } catch (error) {
      const errorData =
        error?.response?.data || {
          statusCode: 500,
          message: "Something went wrong.",
        };
      dispatch({
        type: "DELETE_HOME_VISIT_CONFIG_FAILED",
        payload: errorData,
      });
      toast.error(errorData.message);
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const viewHomeVisitConfig = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_HOME_VISIT_CONFIG_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/vr-home-visit/view/${id}`, 
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "VIEW_HOME_VISIT_CONFIG_SUCCESS",
          payload: data,
        });
        // toast.success("Config fetched successfully!");
        return data;
      } else {
        dispatch({
          type: "VIEW_HOME_VISIT_CONFIG_FAILED",
          payload: data,
        });
        toast.error("Failed to fetch config.");
        return data;
      }
    } catch (error) {
      const errorData =
        error?.response?.data || {
          statusCode: 500,
          message: "Something went wrong.",
        };
      dispatch({
        type: "VIEW_HOME_VISIT_CONFIG_FAILED",
        payload: errorData,
      });
      toast.error(errorData.message);
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getHomeVisitConfigsList = (filters = {}) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_HOME_VISIT_CONFIGS_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/vr-home-visit/list`,
        filters, 
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "GET_HOME_VISIT_CONFIGS_LIST_SUCCESS",
          payload: data,
        });
        // toast.success("Configs fetched successfully!");
        return data;
      } else {
        dispatch({
          type: "GET_HOME_VISIT_CONFIGS_LIST_FAILED",
          payload: data,
        });
        toast.error("Failed to fetch configs.");
        return data;
      }
    } catch (error) {
      const errorData =
        error?.response?.data || {
          statusCode: 500,
          message: "Something went wrong.",
        };
      dispatch({
        type: "GET_HOME_VISIT_CONFIGS_LIST_FAILED",
        payload: errorData,
      });
      toast.error(errorData.message);
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
